import * as React from 'react';
export const IcGamingProfile = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7 5.13a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-2 5h4a1 1 0 001-1 3 3 0 10-6 0 1 1 0 001 1zm17 6.38A5.15 5.15 0 0016.78 12H13v-1a1 1 0 011-1h1.88a3.08 3.08 0 003.06-2.4A3 3 0 0016 4h-2a1 1 0 01-1-1 1.05 1.05 0 00-.29-.71A.999.999 0 0011 3a3 3 0 003 3h2a1 1 0 110 2h-2a3 3 0 00-3 3v1H7.22A5.15 5.15 0 002 16.51a5 5 0 008.66 3.85 1 1 0 01.77-.36h1.1a1 1 0 01.77.36 5 5 0 008.7-3.85zM9 18H8v1a1 1 0 11-2 0v-1H5a1 1 0 110-2h1v-1a1 1 0 012 0v1h1a1 1 0 010 2zm8-4a1 1 0 110 2 1 1 0 010-2zm-2 4A1 1 0 1115 16 1 1 0 0115 18zm2 2A1 1 0 1117 18 1 1 0 0117 20zm2-2A1 1 0 1119 16 1 1 0 0119 18z'
      fill='currentColor'
    />
  </svg>
);
